import { GDFHotPolyHiRecordNormal } from '../../gdf/type';
import { getCopyButtonComponent } from '../copy-button';

export default function TropicalCyclonesProperties({ record }: { record: GDFHotPolyHiRecordNormal }) {
    const Button = getCopyButtonComponent();
    return (
        <div>
            {Button && (
                <div className="pb-2 d-flex justify-content-end">
                    <Button getText={() => record.detail} />
                </div>
            )}
            <pre className="p-2 mt-2 secondary-bg-color" style={{ fontFamily: 'monospace' }}>
                {record.detail}
            </pre>
        </div>
    );
}
